module.exports = __webpack_public_path__ + "img/melody_gardot.e759d190.jpg";